import React from 'react';
import { Modal } from '@makemydeal/dr-ui-bricks-components';

import { SessionExpiredMessage, SessionExpiredOverlayContent, SessionExpiredOverlayRoot } from './SessionExpiredOverlayView.style';

export const SessionExpiredOverlayView = (): React.JSX.Element => (
    <SessionExpiredOverlayRoot data-testid="session-expired-overlay">
        <Modal className="session-expired-overlay-layer">
            <SessionExpiredOverlayContent>
                <SessionExpiredMessage level={4} weight="bold" data-testid="session-expired-overlay-message">
                    Your session has expired. Refresh VinConnect to continue.
                </SessionExpiredMessage>
            </SessionExpiredOverlayContent>
        </Modal>
    </SessionExpiredOverlayRoot>
);
